import { useTranslation } from "react-i18next";

export default function useTranslate(stringBase: string) {
  const { t } = useTranslation();

  function translate(key: string) {
    return t(`${stringBase}.${key}`);
  }

  function translateWithParams(key: string, options: any): string {
    return t(`${stringBase}.${key}`, options) as string;
  }

  function messageTrans(key: string) {
    if (key) return t(`core.message.${key}`);
    return "";
  }

  function buttonTrans(key: string) {
    if (key) return t(`core.button.${key}`);
    return "";
  }

  return { translate, translateWithParams, messageTrans, buttonTrans };
}
